import React, { useState, useEffect, useContext } from "react";
import { AuthContext } from "../../../contexts/AuthContext";
import { Col, Row, Form, Button, FormGroup, Label, Input } from "reactstrap";
import axios from "axios";
import SweetAlert from "sweetalert2-react";
import Swal from "sweetalert2";
import Header from "../../../layout/Header/Header";
import moment from "moment";

import { v4 as uuidv4 } from "uuid";

import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  root: {
    "& .MuiTextField-root": {
      margin: theme.spacing(1),
    },
  },
  button: {
    margin: theme.spacing(1),
  },
}));

function AjusteCreate() {
  const { user } = useContext(AuthContext);
  const URL_LOGS = process.env.REACT_APP_URL_LOGS;
  const URL_AREAS = process.env.REACT_APP_URL_AREAS;
  const URL_ARTICULOS = process.env.REACT_APP_URL_ARTICULOS;
  const URL_AJUSTE = process.env.REACT_APP_URL_AJUSTE;
  const URL_ARTICULOS_AJUSTE = process.env.REACT_APP_URL_ARTICULOS_AJUSTE;
  
  let date = new Date();
  let hoy = moment(date).format("YYYY-MM-DD");

  const [articulos, setArticulos] = useState([]);
  const [areas, setAreas] = useState([]);
  const [selectedArea, setSelectedArea] = useState("");

  const [fecha, setFecha] = useState(hoy);
  const [observaciones, setObservaciones] = useState("NA");
  const [total_piezas, setTotalPiezas] = useState(0);

  const classes = useStyles();
  const [inputFields, setInputFields] = useState([
    {
      id: uuidv4(),
      articuloInicial:"",
      articuloFinal:"",
      arrayColoresInicialArt:[],
      arrayColoresFinalArt:[],
      colorInicial:"",
      colorFinal:"",
      arrayTallasInicialArt:[],
      arrayTallasFinalArt:[],
      tallaInicial:"",
      tallaFinal:"",
      cantidad: 0,
    },
  ]);

  const [validaBoton, setValidaBoton] = useState(true);

  useEffect(() => {
    axios
      .get(URL_ARTICULOS, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((res) => {
        const allArticulos = res.data;
        setArticulos(allArticulos);
      })
      .catch((err) => {
        console.log(err);
      }); 
      axios
        .get(URL_AREAS, {
          headers: {
            Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
          },
        })
        .then((res) => {
          const allAreas = res.data;
          setAreas(allAreas);
        })
        .catch((err) => {
          console.log(err);
        }); 
  }, []);


  const saveOrdenCompra = async (event) => {
    event.preventDefault();
    setValidaBoton(false);
    try {
      await axios
        .post(
          URL_AJUSTE,
          {
            fecha,
            observaciones,
            total_piezas,
          },
          {
            headers: {
              Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
            },
          }
        )
        .then((data) => {
            inputFields.map((a) => {
              axios.post(
                URL_ARTICULOS_AJUSTE,
                {
                  ajuste: data.data._id,
                  fecha,
                  articuloInicial: a.articuloInicial,
                  articuloFinal: a.articuloFinal,
                  colorInicial: a.colorInicial,
                  colorFinal: a.colorFinal,
                  tallaInicial: a.tallaInicial,
                  tallaFinal: a.tallaFinal,
                  cantidad: a.cantidad,
                  areas: selectedArea
                },
                {
                  headers: {
                    Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
                  },
                }
              );
            });
            axios.post(
              URL_LOGS,
              {
                tipo: "Crear Ajuste",
                detalle: `${total_piezas}`,
                user: user.id,
              },
              {
                headers: {
                  Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
                },
              }
            );
            Swal.fire("Good job!", `Creado con exito, OC ${data.data.idOrdenCompra}`, `success`);
            setTimeout(() => {
              window.location.reload();
            }, 1000);

        })
        .catch((error) => {
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: "Something went wrong!",
            footer: `${error.response.data}`,
          });
          console.log(error);
          setValidaBoton(true);
        });
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Something went wrong!",
        footer: `${error.response.data}`,
      });
      console.log(error);
    }

  };
  const handleAddFields = () => {
    const ultimo = inputFields[inputFields.length-1];
    setInputFields([
      ...inputFields,
      {
        id: uuidv4(),
        articuloInicial:"",
        articuloFinal:"",
        arrayColoresInicialArt:[],
        arrayColoresFinalArt:[],
        colorInicial:"",
        colorFinal:"",
        arrayTallasInicialArt:[],
        arrayTallasFinalArt:[],
        tallaInicial:"",
        tallaFinal:"",
        cantidad: 0,
      },
    ]);
  };

  const handleRemoveFields = (id) => {
    const values = [...inputFields];
    values.splice(
      values.findIndex((value) => value.id === id),
      1
    );
    setInputFields(values);
    let totalPZ = values.map((c) => parseFloat(c.cantidad));
    let TP = totalPZ.reduce((t, total, index) => t + total, 0);
    setTotalPiezas(TP);
  };

  const handleChangeInput = (id, event) => {
    const newInputFields = inputFields.map((i) => {
      if (id === i.id) {
        i[event.target.name] = event.target.value;
      }
      return i;
    });
    setInputFields(newInputFields);
    ActualizaTotales()
  };

  console.log("hola", inputFields)

  function BuscaArticulosInicial(id, event){
    articulos.map((a)=>{
      if(a._id == event.target.value){
        let articuloInicial = a._id
        let coloresInicialArt = a.colores
        let tallasInicialArt = a.tallas
        handleChangeInputArticulosInicial(id, articuloInicial, coloresInicialArt, tallasInicialArt)
      }
    })
  }

  const handleChangeInputArticulosInicial = (id, articuloInicial, coloresInicialArt, tallasInicialArt) => {
    const newInputFields = inputFields.map((i) => {
      if (id === i.id) {
        i.articuloInicial = articuloInicial;
        i.arrayColoresInicialArt = coloresInicialArt
        i.arrayTallasInicialArt = tallasInicialArt
      }
      return i;
    });
    setInputFields(newInputFields);
    ActualizaTotales()
  };

  function BuscaArticulosFinal(id, event){
    articulos.map((a)=>{
      if(a._id == event.target.value){
        let articuloFinal = a._id
        let coloresFinalArt = a.colores
        let tallasFinalArt = a.tallas
        handleChangeInputArticulosFinal(id, articuloFinal, coloresFinalArt, tallasFinalArt)
      }
    })
  }

  const handleChangeInputArticulosFinal = (id, articuloFinal, coloresFinalArt, tallasFinalArt) => {
    const newInputFields = inputFields.map((i) => {
      if (id === i.id) {
        i.articuloFinal = articuloFinal;
        i.arrayColoresFinalArt = coloresFinalArt
        i.arrayTallasFinalArt = tallasFinalArt
      }
      return i;
    });
    setInputFields(newInputFields);
    ActualizaTotales()
  };


  function ActualizaTotales(){
        let totalPZ = inputFields.map((c) => parseFloat(c.cantidad));
        let TP = totalPZ.reduce((t, total, index) => t + total, 0);
        setTotalPiezas(TP);
  }

  return (
    <>
      <Header />
      <br />
      <br />
      {user.oc_create ? (
        <div className="card container col-12">
          <h3 align="center">Nuevo Ajuste</h3>
          <Form onSubmit={saveOrdenCompra}>
            <Row>
              <Col md={2}>
                <Label>Fecha</Label>
                <Input
                  type="date"
                  placeholder="Fecha"
                  value={fecha}
                  disabled
                  // required
                  // onChange={(e) => {
                  //   setFecha(e.target.value);
                  // }}
                />
              </Col>
              <Col md={2}>
                <Label>Almacen</Label>
                <Input
                  type="select"
                  value={selectedArea}
                  onChange={(e) => {
                    setSelectedArea(e.target.value);
                  }}
                >
                  <option value="">Selecciona</option>
                  {areas
                    .sort((a, b) => (a.name > b.name ? 1 : -1))
                    .map((a) => {
                      return <option value={a._id}>{a.name}</option>;
                    })}
                </Input>
              </Col>
              <Col md={5}>
                <Label for="exampleEmail" className="mr-sm-2">
                  Observaciones
                </Label>
                <Input
                  type="text"
                  placeholder="Observaciones"
                  value={observaciones}
                  required
                  onChange={(e) => {
                    setObservaciones(e.target.value);
                  }}
                />
              </Col>
              <Col md={3}>
                <h4 id="logoutBoton">TOTAL {total_piezas} pzas.</h4>
              </Col>
            </Row>

            {/* Tabla Articulos */}
            <Row>
              <Col md={2}>
                <Label className="mr-sm-2">Articulo Inicial</Label>
              </Col>
              <Col md={1}>
                <Label className="mr-sm-2">Color Inicial</Label>
              </Col>
              <Col md={1}>
                <Label className="mr-sm-2">Talla Inicial</Label>
              </Col>
              <Col md={1}>
                <Label className="mr-sm-2">Cantidad</Label>
              </Col>
              <Col md={2}>
                <Label className="mr-sm-2">Articulo Final</Label>
              </Col>
              <Col md={1}>
                <Label className="mr-sm-2">Color Final</Label>
              </Col>
              <Col md={1}>
                <Label className="mr-sm-2">Talla Final</Label>
              </Col>
            </Row>

            {inputFields.map((inputField) => (
              <div key={inputField.id}>
                <Row>
                  <Col md={2}>
                    <Input
                      bsSize="sm"
                      name="articuloInicial"
                      type="select"
                      value={inputField.articuloInicial}
                      required
                      onChange={(event) => {
                        BuscaArticulosInicial(inputField.id, event);
                      }}
                    >
                      <option value="">Selecciona</option>
                      {articulos
                        .sort((a, b) => (a.codigo > b.codigo ? 1 : -1))
                        .map((a) => {
                          return (
                            <option value={a._id}>
                              {a.codigo} / {a.descripcion}
                            </option>
                          );
                        })}
                    </Input>
                  </Col>
                  <Col md={1}>
                    <Input
                      bsSize="sm"
                      name="colorInicial"
                      type="select"
                      value={inputField.colorInicial}
                      required
                      onChange={(event) =>
                        handleChangeInput(inputField.id, event)
                      }
                    >
                      <option value="">Selecciona</option>
                      {inputField.arrayColoresInicialArt
                        .sort((a, b) => (a.name > b.name ? 1 : -1))
                        .map((a) => {
                          return <option value={a._id}>{a.name}</option>;
                        })}
                    </Input>
                  </Col>
                  <Col md={1}>
                    <Input
                      bsSize="sm"
                      name="tallaInicial"
                      type="select"
                      value={inputField.tallaInicial}
                      required
                      onChange={(event) =>
                        handleChangeInput(inputField.id, event)
                      }
                    >
                      <option value="">Selecciona</option>
                      {inputField.arrayTallasInicialArt
                        .sort((a, b) => (a.name > b.name ? 1 : -1))
                        .map((a) => {
                          return <option value={a._id}>{a.name}</option>;
                        })}
                    </Input>
                  </Col>

                  <Col md={1}>
                    <Input
                      bsSize="sm"
                      name="cantidad"
                      type="number"
                      placeholder="Cantidad"
                      value={inputField.cantidad}
                      required
                      onChange={(event) =>
                        handleChangeInput(inputField.id, event)
                      }
                    />
                  </Col>

                  <Col md={2}>
                    <Input
                      bsSize="sm"
                      name="articuloFinal"
                      type="select"
                      value={inputField.articuloFinal}
                      required
                      onChange={(event) => {
                        BuscaArticulosFinal(inputField.id, event);
                      }}
                    >
                      <option value="">Selecciona</option>
                      {articulos
                        .sort((a, b) => (a.codigo > b.codigo ? 1 : -1))
                        .map((a) => {
                          return (
                            <option value={a._id}>
                              {a.codigo} / {a.descripcion}
                            </option>
                          );
                        })}
                    </Input>
                  </Col>
                  <Col md={1}>
                    <Input
                      bsSize="sm"
                      name="colorFinal"
                      type="select"
                      value={inputField.colorFinal}
                      required
                      onChange={(event) =>
                        handleChangeInput(inputField.id, event)
                      }
                    >
                      <option value="">Selecciona</option>
                      {inputField.arrayColoresFinalArt
                        .sort((a, b) => (a.name > b.name ? 1 : -1))
                        .map((a) => {
                          return <option value={a._id}>{a.name}</option>;
                        })}
                    </Input>
                  </Col>
                  <Col md={1}>
                    <Input
                      bsSize="sm"
                      name="tallaFinal"
                      type="select"
                      value={inputField.tallaFinal}
                      required
                      onChange={(event) =>
                        handleChangeInput(inputField.id, event)
                      }
                    >
                      <option value="">Selecciona</option>
                      {inputField.arrayTallasFinalArt
                        .sort((a, b) => (a.name > b.name ? 1 : -1))
                        .map((a) => {
                          return <option value={a._id}>{a.name}</option>;
                        })}
                    </Input>
                  </Col>
                  <Col>
                    <Button
                      size="sm"
                      className="btn"
                      color="danger"
                      disabled={inputFields.length === 1}
                      onClick={() => handleRemoveFields(inputField.id)}
                      tabindex="-1"
                    >
                      <i class="fas fa-minus"></i>
                    </Button>
                    <Button
                      size="sm"
                      className="btn"
                      color="info"
                      onClick={handleAddFields}
                      tabindex="-1"
                    >
                      <i class="fas fa-plus"></i>
                    </Button>
                  </Col>
                </Row>
              </div>
            ))}
            <Row>
              <Col md={10}>
                <h4 id="logoutBoton">TOTAL {total_piezas} pzas.</h4>
              </Col>
            </Row>
            {/* Termina Tabla Tableros */}

            <br />
            {validaBoton ? (
              <Button type="submit" className="btn btn-success">
                Guardar
              </Button>
            ) : (
              <Button type="submit" className="btn btn-success" disabled>
                Guardar
              </Button>
            )}
            <Button
              href="/ListadoAjuste"
              className="btn btn-danger"
              id="botonListado"
            >
              Regresar
            </Button>
          </Form>
          <br />
        </div>
      ) : undefined}
    </>
  );
}

export default AjusteCreate;
